import './css/landing.css';


import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';



import {Swiper,SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-cube';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {Autoplay,EffectCube,EffectCoverflow,Navigation,Pagination} from 'swiper';



function Landing(){
    return(
        <>
            <section className="landing">

                <div className='container-fluid'>
                    <div className='row'>

                    <div className="col-lg-3 col-md-4 col-sm-12 col-12">

                                        
                        <div className="side-nav">
                            <div className="header">
                                <h1><i className="fa-solid fa-bars"></i> أفضل الأقسام </h1>
                            </div>

                            <ul>

                                <li><a href=""> مكياج أحلى ساكورا <i className="fa-solid fa-chevron-right"></i></a></li>
                                <li><a href=""> مكياج أحلى ساكورا  <i className="fa-solid fa-chevron-right"></i></a></li>
                                <li><a href=""> مكياج أحلى ساكورا  <i className="fa-solid fa-chevron-right"></i></a></li>
                                <li><a href=""> مكياج أحلى ساكورا  <i className="fa-solid fa-chevron-right"></i></a></li>
                                <li><a href=""> مكياج أحلى ساكورا  <i className="fa-solid fa-chevron-right"></i></a></li>

                            </ul>
                        </div>

                        </div>


                        <div  className="col-lg-9 col-md-8 col-sm-12 col-12">
                            <div className="upper-slider">
                                <div className="slider">



                                <Swiper  grabCursor={true} slidesPerView={'auto'} navigation={{
                                    nextEl: '.next-btn',
                                    prevEl: '.prev-btn',
                                    }} pagination={true}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                    modules={[Autoplay,EffectCoverflow,EffectCube,Navigation,Pagination]}
                                    >
                                        <SwiperSlide>
                                            <div className="slide">
                                                <div className="slide-content">
                                                    <img src={AnimeShapes1} alt="animeproduct"/>
                                                    <div className="text">
                                                        <h1> نحن نوفر لك كل المنتجات اليابانية التي تحتاج من اليابان مباشرة لك </h1>
                                                        <a href="#">
                                                            تواصل معنا
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide>
                                            
                                            <div className="slide">
                                                <div  className="slide-content">
                                                <img src={AnimeShapes2} alt="animeproduct"/>
                                                    <div  className="text">
                                                        <h1> جميع المنتجات اليابانية في مكان واحد </h1>
                                                        <a   href="#">
                                                        تواصل معنا
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>




                                        <SwiperSlide>
                                            

                                            <div className="slide">
                                                <div className="slide-content">
                                                <img src={AnimeShapes3} alt="animeproduct"/>
                                                    <div   className="text">
                                                        <h1> نقوم بأستيراد جميع المنتجات من اليابان </h1>
                                                        <a href="#">
                                                        تواصل معنا
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>



                                </Swiper>



                                </div>
                            </div>


                            <div className='row'>

                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="landing-ad">
                                    <div className="overlay"></div>
                                    <h2> نحن نوفر لك كل المنتجات اليابانية التي تحتاج من اليابان مباشرة لك </h2>
                                    <h1>مكياج أحلى ساكورا</h1>
                                    
                                </div>
                            </div>


                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="landing-ad">
                                    <div className="overlay"></div>
                                    <h2> جميع المنتجات اليابانية في مكان واحد </h2>
                                    <h1> منتجات تجميل   </h1>
                                </div>
                            </div>
                            </div>

                        </div>

                    </div>
                </div>
                
            </section>



        </>
    )

}

export default Landing;